import React from 'react';
import SelectOptionModal from './SelectOption';
import { useDispatch } from 'react-redux';
import { useAuthContext } from '@repo/hooks';
import { buildReferralActions } from '@components/utils/referral-sharing';

export default function ShareInviteModal({ closeModal }) {
  const dispatch = useDispatch();
  const { user } = useAuthContext();
  const options = buildReferralActions(user, dispatch, closeModal);

  return <SelectOptionModal closeModal={closeModal} header="Share Clay Invite" options={options} />;
}
